document.addEventListener("DOMContentLoaded", function () {

  
  /* =========================================================================
   * 1. TOAST
   * ====================================================================== */
  const TOAST_ICONS = {
  success: `
    <svg width="40" height="40" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.0098 2.51294C37.434 2.51294 47.5098 12.5887 47.5098 25.0129C47.5098 37.4372 37.434 47.5129 25.0098 47.5129C12.5855 47.5129 2.50977 37.4372 2.50977 25.0129C2.50977 12.5887 12.5855 2.51294 25.0098 2.51294ZM20.3374 32.3211L14.8288 26.808C13.8903 25.869 13.8901 24.3377 14.8288 23.3989C15.7677 22.4602 17.3058 22.4661 18.2378 23.3989L22.1213 27.2854L31.7821 17.6246C32.721 16.6857 34.2524 16.6857 35.1911 17.6246C36.1299 18.5632 36.1286 20.096 35.1911 21.0335L23.823 32.4016C22.8855 33.3391 21.3527 33.3405 20.414 32.4016C20.3877 32.3752 20.3622 32.3484 20.3374 32.3211Z" fill="#6E9C1C"/>
    </svg>
  `,

  error: `
    <svg width="40" height="40" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="22" stroke="#E53935" stroke-width="4"/>
      <path d="M18 18L32 32M32 18L18 32" stroke="#E53935" stroke-width="4" stroke-linecap="round"/>
    </svg>
  `,
};

function toastMessage(message, isSuccess = true) {
  const toast = document.createElement("div");

  toast.className = "cart-success-msg";

  toast.style.cssText = `
    position: fixed;
    bottom: 30px;
    left: 0;
    right: 0;
    margin-inline: auto;
    width: fit-content;
    background: #FBFFEE;
    border: .5px solid ${isSuccess ? "#6E9C1C" : "#E53935"};
    color: #03080F;
    padding: 13px 18px;
    border-radius: 8px;
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 20px;
    animation: fadeIn .3s ease;
  `;

  toast.innerHTML = `
    <div class="msg-text">
      ${isSuccess ? TOAST_ICONS.success : TOAST_ICONS.error}
      <p>${message}</p>
    </div>

    <button class="success-modal__close" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M12.9988 13L1 1M1.00128 13L13 1"
              stroke="#2E2E2E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>
    </button>
  `;

  document.body.appendChild(toast);

  const removeToast = () => toast.remove();

  toast
    .querySelector(".success-modal__close")
    .addEventListener("click", removeToast);

  setTimeout(removeToast, 3000);
}

  /* =========================================================================
   * 1B. DELIVERY-AVAILABILITY GUARD (integrates with zipcode.js)
   * ====================================================================== */

  /**
   * Global, single-source-of-truth delivery guard — defined once in
   * zipcode.js (window.DeliveryAvailability.guard) and reused here.
   *
   * If the product IS deliverable to the last-checked pincode, `onAllowed`
   * fires immediately and this returns true.
   * If NOT deliverable (or no pincode set yet), the delivery popup opens
   * and `onAllowed` is stored to auto-resume once a valid, deliverable
   * pincode is confirmed. Returns false in this case.
   */
  function deliveryGuard(productId, onAllowed) {
    if (!window.DeliveryAvailability || !window.DeliveryAvailability.guard) {
      if (onAllowed) onAllowed();
      return true;
    }
    const allowed = window.DeliveryAvailability.guard(productId, onAllowed);
    if (allowed && typeof onAllowed === 'function') {
      onAllowed();
    }
    return allowed;
  }

  // Simple boolean-style helper for spots that just need a yes/no gate
  // (no resume needed once the pincode is confirmed later).
  function blockForDelivery(productId) {
    return !deliveryGuard(productId, function () {});
  }

  /* =========================================================================
   * 2. CART DATA LAYER
   * ====================================================================== */

  function refreshCartCount(itemCount) {
    $('.cart-count')
      .text(itemCount)
      .removeAttr("hidden")
      .attr("aria-label", itemCount);
  }

  function getCart() {
    return $.getJSON('/cart.js');
  }

  function fireCartRefreshEvent(open) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !!open } }));
  }

  function ajaxAddToCart(variantId, qty, onSuccess, onError) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
      dataType: 'json',
      contentType: 'application/json',
      success: function () {
        getCart().done(function (cart) {
          refreshCartCount(cart.item_count);
          fireCartRefreshEvent(false);
          toastMessage('An item has been added to your basket successfully.');
          if (onSuccess) onSuccess(cart);
        });
      },
      error: function (err) { if (onError) onError(err); }
    });
  }

  function ajaxAddItemsToCart(items, onSuccess, onError) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items }),
      dataType: 'json',
      contentType: 'application/json',
      success: function () {
        getCart().done(function (cart) {
          refreshCartCount(cart.item_count);
          if (onSuccess) onSuccess(cart);
        });
      },
      error: function (err) { if (onError) onError(err); }
    });
  }

function ajaxUpdateCart(variantId, type, newQty, onSuccess, onError) {
  getCart()
    .done(function (cart) {
      const cartData = cart && cart.responseJSON ? cart.responseJSON : cart;

      const item = cartData.items.find(i => i.variant_id === variantId);

      if (!item) {
        if (type === 'increment') {
          ajaxAddToCart(variantId, 1, onSuccess, onError);
        } else {
          if (onError) onError('item_not_found');
        }
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify({ id: item.key, quantity: newQty }),
        dataType: 'json',
        contentType: 'application/json',
        success: function (updatedCart) {
          refreshCartCount(updatedCart.item_count);
          fireCartRefreshEvent(false);
          if (newQty > 0) toastMessage('Cart has been updated successfully.');
          if (onSuccess) onSuccess(updatedCart);
        },
        error: function (err) { if (onError) onError(err); }
      });
    })
    .fail(function (err) {
      console.error('Failed to load cart:', err);
      if (onError) onError('cart_fetch_failed');
    });
}

  /* =========================================================================
   * 3. LOADING-STATE HELPERS
   * ====================================================================== */

  function startQtyLoading(qtyRow, minusBtn, plusBtn) {
    if (!qtyRow) return;
    qtyRow.classList.add('qty-row-loading');
    qtyRow.dataset.loading = '1';
    if (minusBtn) minusBtn.disabled = true;
    if (plusBtn) plusBtn.disabled = true;
  }

  function stopQtyLoading(qtyRow, minusBtn, plusBtn) {
    if (!qtyRow) return;
    qtyRow.classList.remove('qty-row-loading');
    delete qtyRow.dataset.loading;
    if (minusBtn) minusBtn.disabled = false;
    if (plusBtn) plusBtn.disabled = false;
  }

  function isQtyLoading(qtyRow) {
    return !!(qtyRow && qtyRow.dataset.loading);
  }

  function startAtcLoading(atcBtn) {
    atcBtn.disabled = true;
    atcBtn.dataset.loading = '1';
    atcBtn.classList.add('btn--atc-loading');
  }

  function stopAtcLoading(atcBtn) {
    atcBtn.disabled = false;
    delete atcBtn.dataset.loading;
    atcBtn.classList.remove('btn--atc-loading');
  }

  function isAtcLoading(atcBtn) {
    return !!(atcBtn && atcBtn.dataset.loading);
  }

  function syncRowHeight(sourceEl, qtyRowEl) {
    const h = sourceEl.offsetHeight;
    if (h > 0) {
      qtyRowEl.style.height = h + 'px';
      const qtyDiv = qtyRowEl.querySelector('.quantity');
      if (qtyDiv) qtyDiv.style.height = h + 'px';
    }
  }

  function transitionToQtyRow(qtyRow, minusBtn, plusBtn, qtyInputEl, minQty) {
    qtyInputEl.value = minQty;
    qtyRow.style.display = 'block';
    startQtyLoading(qtyRow, minusBtn, plusBtn);
    setTimeout(function () {
      stopQtyLoading(qtyRow, minusBtn, plusBtn);
    }, 400);
  }

  /* =========================================================================
   * 4. VARIANT MODAL — multi-item add
   * ====================================================================== */

  $(".variant-modal__body").off("click", ".variant-modal_add,.variant-collection_card");
  $(".variant-modal__body").off("click", ".quantity__button");
  $(".variant-modal__body").off("input", ".quantity__input");

  function getModalErrorBox(modal) {
    let messageBox = modal.find(".form-error-jtpl");
    if (!messageBox.length) {
      messageBox = $('<div class="form-error-jtpl"></div>')
        .appendTo(modal.find(".variant-modal__content, .variant-modal__body").first());
    }
    return messageBox;
  }

  function closeVariantModal(modal) {
    modal.attr("aria-hidden", "true").removeClass("active");
    $("body").removeAttr("modal-show");
  }

  function updateTotalPrice() {
    let total = 0;
    $(".variant-item-wrapper.is-selected").each(function () {
      const price = parseFloat($(this).data("price"));
      const qty = parseInt($(this).find(".quantity__input").val()) || 0;
      if (!isNaN(price) && qty > 0) total += price * qty;
    });
    $(".variant-total__price").text("₹ " + total.toFixed(2));
  }

  $(document).on("click", ".variant-modal__btn--confirm", function (e) {
    e.preventDefault();
    const $btn = $(this);
    if ($btn.hasClass("is-loading")) return;

    const modal = $btn.closest(".variant-modal");
    const messageBox = getModalErrorBox(modal);
    messageBox.html("").hide();

    const items = [];
    let blockedByDelivery = false;

    modal.find(".variant-item-wrapper.is-selected").each(function () {
      const $row = $(this);
      const productId = $row.data("product-id") || modal.find("[data-attr]").data("attr");

      if (blockForDelivery(productId)) {
        blockedByDelivery = true;
        return false; // break .each
      }

      items.push({
        id: $row.attr("data-variant-id"),
        quantity: $row.find(".quantity__input").val() || 1
      });
    });

    if (blockedByDelivery) {
      return false;
    }

    $btn.addClass("is-loading");

    if (items.length === 0) {
      messageBox.html("Please select at least one variant!").fadeIn();
      $btn.removeClass("is-loading");
      return false;
    }

    ajaxAddItemsToCart(
      items,
      function () {
        $btn.removeClass("is-loading");
        messageBox.html("Items added successfully!").fadeIn(300).delay(2000).fadeOut(500);
        document.activeElement.blur();
        closeVariantModal(modal);

        const behavior = window.addToCartBehavior || "open_drawer";
        if (behavior === "open_drawer") {
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:open'));
            fireCartRefreshEvent(true);
          }, 300);
        } else {
          setTimeout(() => $("body").removeClass("modal-showing"), 1000);
          setTimeout(() => fireCartRefreshEvent(false), 300);
          toastMessage('An item has been added to your basket successfully.');
        }
      },
      function (err) {
        $btn.removeClass("is-loading");
        console.error('Error adding items:', err);
        messageBox.html("Something went wrong!").fadeIn();
      }
    );

    return false;
  });

  $(document).on("click", ".quantity__button", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $input = $(this).closest(".quantity").find(".quantity__input");
    $(".variant-modal__footer .form-error-jtpl").html("");
    $(".variant-modal__footer .variant-card-collection").attr("data-quantity", $input.val());
    updateTotalPrice();
  });

  $(document).on("input", ".quantity__input", function () {
    const qty = parseInt($(this).val()) || 0;
    $(this).closest(".variant-item-wrapper").toggleClass("is-selected", qty > 0);
    $(".variant-modal__footer .form-error-jtpl").html("");
    updateTotalPrice();
  });

  /* =========================================================================
   * 5. "SET AS" — single variant pick inside modal
   * ====================================================================== */
    $("body")
        .off("click.mhfVariantSelect", ".model_select_varint")
        .on("click.mhfVariantSelect", ".model_select_varint", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $modal = $(this).closest(".variant-modal");
            const $variantRow = $(this).closest(".variant-item-wrapper");
            const $productCard = $modal.closest(".product-card__list-actions");

            const variantId = parseInt($variantRow.data("variant-id"), 10);
            const productId = $variantRow.data("product-id") || $modal.find("[data-attr]").data("attr");
            const variantTitle = $variantRow.find(".variant-title").text().trim();
            const isAvailable =
                $variantRow.data("available") !== false &&
                $variantRow.data("available") !== "false";

            if (blockForDelivery(productId)) {
                $modal.attr("aria-hidden", "true").removeClass("is-active open active");
                $("body").removeClass("overflow-hidden");
                return;
            }

            // Update selected variant
            $productCard.find('input[name="id"]').val(variantId);

            $productCard
                .find(".selectr-types")
                .contents()
                .filter(function () {
                    return this.nodeType === 3;
                })
                .first()
                .replaceWith(variantTitle + " ");

            $productCard
                .find("[data-quantity-variant-id]")
                .attr("data-quantity-variant-id", variantId);

            const $qtyRow = $productCard.find("[data-qty-row]");
            const $atcBtn = $productCard.find("[data-atc-trigger]");
            const $qtyInput = $productCard.find("[data-qty-input]");

            const qtyRow = $qtyRow[0];
            const atcBtn = $atcBtn[0];
            const minusBtn = qtyRow
                ? qtyRow.querySelector("[data-qty-minus]")
                : null;
            const plusBtn = qtyRow
                ? qtyRow.querySelector("[data-qty-plus]")
                : null;

            // Reset UI
            $qtyRow.hide();
            $atcBtn.show().prop("disabled", !isAvailable);

            // Close modal
            $modal.attr("aria-hidden", "true")
                .removeClass("is-active open active");

            $("body").removeClass("overflow-hidden");

            if (!isAvailable || !atcBtn) {
                return;
            }

            // Show loading state
            startAtcLoading(atcBtn);

            ajaxAddToCart(
                variantId,
                1,
                function () {
                    stopAtcLoading(atcBtn);

                    const min = parseInt($qtyInput.attr("min"), 10) || 1;

                    syncRowHeight(atcBtn, qtyRow);
                    $atcBtn.hide();

                    transitionToQtyRow(
                        qtyRow,
                        minusBtn,
                        plusBtn,
                        $qtyInput[0],
                        min
                    );
                },
                function (err) {
                    stopAtcLoading(atcBtn);
                    console.error("Set As - add to cart failed:", err);
                }
            );
        });
  // Function to recalculate and update the total price
  function updateTotalPrice() {
    let total_price = 0;

    $(".variant-item-wrapper.is-selected").each(function () {
      const $wrapper = $(this);
      const price = parseFloat($wrapper.data("price"));
      const qty = parseInt($wrapper.find(".quantity__input").val()) || 0;

      if (!isNaN(price) && qty > 0) {
        total_price += price * qty;
      }
    });

    $(".variant-total__price").text("₹ " + total_price.toFixed(2));
  }

  // Remove existing event listeners to prevent duplicates
  $(".variant-modal__body").off("click", ".variant-modal_add ,.variant-collection_card");
  $(".variant-modal__body").off("click", "#quantity__button_minus");
  $(".variant-modal__body").off("input", "#quantity__button_plus");

  // Handle "Add" button click
  $("body").on("click", ".recently-viewed-products .variant-modal__body .variant-modal_add,.variant-modal__body .variant-modal_add ,.variant-modal__body .variant-collection_card", function (e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling

    const $btn = $(this);
    const $variantWrapper = $btn.closest(".variant-item-wrapper");
    const productId = $variantWrapper.data("product-id") || $btn.closest(".variant-modal").find("[data-attr]").data("attr");

    if (blockForDelivery(productId)) {
      return;
    }

    $variantWrapper.addClass("is-selected");
    $variantWrapper.find(".quantity__input").val(1);
    $(".variant-modal__footer .form-error-jtpl").html("");
    updateTotalPrice();
  });

  // Handle quantity change (plus/minus buttons)
  $(document).on("click", "#quantity__button_minus", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $input = $(this).closest(".quantity").find(".quantity__input");
    const $updatequntity = $input.val();

    $(".variant-modal__footer .form-error-jtpl").html("");
    $(".variant-modal__footer .variant-card-collection").attr("data-quantity", $updatequntity);
    updateTotalPrice();
  });

  // Handle manual quantity input
  $(document).on("input", "#quantity__button_plus", function (e) {
    const qty = parseInt($(this).val()) || 0;
    const $variantWrapper = $(this).closest(".variant-item-wrapper");
    if (qty === 0) {
      $variantWrapper.removeClass("is-selected");
    } else {
      $variantWrapper.addClass("is-selected");
    }

    $(".variant-modal__footer .form-error-jtpl").html("");
    updateTotalPrice();
  });

  /* =========================================================================
   * 6. VARIANT MODAL — open / close, slider housekeeping
   * ====================================================================== */

  function pauseSlidersForModal($trigger) {
    const featuredCollection = $trigger.parents("featured-collection").get(0);
    if (featuredCollection && featuredCollection.querySelector(".collection-list-slider")) {
      requestAnimationFrame(() => {
        const isDesktop = $(window).width() >= 768;
        $("featured-collection.swiper-initialized")
          .toggleClass("swiper-backface-hidden", !isDesktop)
          .addClass("swiper-hidden-jtpl");
        featuredCollection.dispatchEvent(new Event("destroy-slider"));
      });
    }

    const recentlyViewed = document.querySelector("recently-viewed-products");
    if (recentlyViewed && recentlyViewed.querySelector(".section--recently-viewed-products")) {
      recentlyViewed.dispatchEvent(new Event("destroy-slider"));
      $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid")
        .removeClass("swiper-wrapper");
      setTimeout(() => {
        $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap")
          .removeClass("swiper-backface-hidden");
      }, 1);
    }
  }

  function resumeSlidersAfterModalClose($trigger) {
    if ($trigger.parents("featured-collection").find(".collection-list-slider").length > 0) {
      const isDesktop = $(window).width() >= 768;
      if (isDesktop) {
        document.querySelector('featured-collection').dispatchEvent(new Event('init-slider'));
      }
      $("featured-collection.swiper-initialized")
        .addClass("swiper-backface-hidden")
        .removeClass("swiper-hidden-jtpl");
    }

    const recentlyViewed = document.querySelector("recently-viewed-products");
    if (recentlyViewed && recentlyViewed.querySelector(".section--recently-viewed-products")) {
      recentlyViewed.dispatchEvent(new Event("init-slider"));
      const $wrap = $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap");
      $wrap.addClass("swiper-backface-hidden");
      $wrap.find(".products-grid").addClass("swiper-wrapper");
      setTimeout(() => {
        $wrap.addClass("swiper-backface-hidden");
        $wrap.find(".products-grid").addClass("f-grid swipe-mobile__inner");
      }, 2);
    }
  }

  $("body").on("click", ".selectr-types", function (e) {
    e.preventDefault();
    const $trigger = $(this);
    const target = $trigger.attr("data-target");

    $(".variant-modal").attr("aria-hidden", "true");
    $(target).attr("aria-hidden", "false");
    $(".form-error-jtpl").html("");
    $(".variant-item-wrapper").removeClass("is-selected");
    $(".variant-total__price").html("₹ 0.00");

    pauseSlidersForModal($trigger);
  });

  $("body").on("click", ".recently-viewed-products .variant-modal__close, .variant-modal__close", function (e) {
    e.preventDefault();
    const $trigger = $(this);

    $trigger.parents(".product-card").find(".selectr-types controls").focus();
    $(".variant-modal").attr("aria-hidden", "true");

    const currentScroll = window.scrollY;
    window.scrollTo(0, currentScroll);

    resumeSlidersAfterModalClose($trigger);

    $trigger.parents(".product-card").find(".selectr-types controls").focus();
    window.scrollTo(0, currentScroll);
  });

  /* =========================================================================
   * 7. CART DRAWER
   * ====================================================================== */

  $(document).on("click", ".drawer__close-btn", function () {
    $("#CartDrawer").removeAttr("open active").removeClass("active");
    $("body").removeClass("modal-show");
  });

  /* =========================================================================
   * 8. PRODUCT CARD — ATC button ⇄ qty stepper, per card
   * ====================================================================== */

  if (!window.__qtyAtcInit) {
    window.__qtyAtcInit = true;

    function initProductCard(form) {
      if (form.__qtyAtcReady) return;
      form.__qtyAtcReady = true;

      const atcTrigger = form.querySelector('[data-atc-trigger]');
      const qtyRow = form.querySelector('[data-qty-row]');
      const minusBtn = form.querySelector('[data-qty-minus]');
      const plusBtn = form.querySelector('[data-qty-plus]');
      const qtyInput = form.querySelector('[data-qty-input]');
      const inputWrapper = form.querySelector('[data-qty-wrapper]');

      if (!atcTrigger || !qtyRow || !qtyInput || !inputWrapper) return;

      const min = parseInt(qtyInput.getAttribute('min')) || 1;
      const step = parseInt(qtyInput.getAttribute('step')) || 1;

      function currentVariantId() {
        return parseInt(qtyInput.dataset.quantityVariantId);
      }

      function currentProductId() {
        const hidden = form.querySelector('input[name="product-id"]');
        if (hidden) return hidden.value;
        if (form.dataset.productId) return form.dataset.productId;
        return null;
      }

      function showInputLoader() {
        const loader = inputWrapper.querySelector('[data-qty-loader]');
        if (loader) loader.style.display = 'block';
        qtyInput.style.color = 'transparent';
        qtyInput.style.caretColor = 'transparent';
        qtyInput.disabled = true;
      }

      function hideInputLoader() {
        const loader = inputWrapper.querySelector('[data-qty-loader]');
        if (loader) loader.style.display = 'none';
        qtyInput.style.color = '';
        qtyInput.style.caretColor = '';
        qtyInput.disabled = false;
      }

      // ── ADD TO CART ──

      atcTrigger.addEventListener('click', function () {
        if (isAtcLoading(atcTrigger)) return;

        deliveryGuard(currentProductId(), function () {
          syncRowHeight(atcTrigger, qtyRow);
          startAtcLoading(atcTrigger);

          ajaxAddToCart(
            currentVariantId(),
            min,
            function () {
              stopAtcLoading(atcTrigger);
              atcTrigger.style.display = 'none';
              transitionToQtyRow(qtyRow, minusBtn, plusBtn, qtyInput, min);
            },
            function (err) {
              stopAtcLoading(atcTrigger);
              console.error(err);
            }
          );
        });
      });

      // ── PLUS ──
      plusBtn.addEventListener('click', function () {
  if (isQtyLoading(qtyRow)) return;

  deliveryGuard(currentProductId(), function () {
    const max = qtyInput.max ? parseInt(qtyInput.max) : Infinity;
    const val = parseInt(qtyInput.value) || min;
    if (val + step > max) return;

    startQtyLoading(qtyRow, minusBtn, plusBtn);
    showInputLoader();

    ajaxUpdateCart(
      currentVariantId(),
      'increment',
      val + step,
      function (updatedCart) {
        const cartData = updatedCart && updatedCart.responseJSON ? updatedCart.responseJSON : updatedCart;
        const item = cartData.items && cartData.items.find(i => i.variant_id === currentVariantId());
        qtyInput.value = item ? item.quantity : 1;

        hideInputLoader();
        stopQtyLoading(qtyRow, minusBtn, plusBtn);
      },
      function (err) {
        hideInputLoader();
        stopQtyLoading(qtyRow, minusBtn, plusBtn);

        if (err === 'item_not_found') {
          toastMessage('Item is no longer valid. Please refresh the page.');
        } else {
          console.error(err);
          toastMessage('Something went wrong. Please try again.');
        }
      }
    );
  });
});

      // ── MINUS ── (never blocked — reducing/removing is always allowed)
      minusBtn.addEventListener('click', function () {
        if (isQtyLoading(qtyRow)) return;

        const val = parseInt(qtyInput.value) || min;
        const newQty = (val - step < min) ? 0 : val - step;

        startQtyLoading(qtyRow, minusBtn, plusBtn);
        showInputLoader();

        ajaxUpdateCart(
          currentVariantId(),
          'decrement',
          newQty,
          function () {
            if (newQty === 0) {
              qtyRow.style.display = 'none';
              atcTrigger.style.display = '';
            } else {
              qtyInput.value = newQty;
            }
            hideInputLoader();
            stopQtyLoading(qtyRow, minusBtn, plusBtn);
          },
          function (err) {
            hideInputLoader();
            stopQtyLoading(qtyRow, minusBtn, plusBtn);

            if (err === 'item_not_found') {
              qtyRow.style.display = 'none';
              atcTrigger.style.display = '';
              toastMessage('Item is no longer in your cart.');
            } else {
              console.error(err);
              toastMessage('Something went wrong. Please try again.');
            }
          }
        );
      });
    }

    document.querySelectorAll('.product-card__list-actions-main').forEach(initProductCard);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.product-card__list-actions-main')) initProductCard(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('.product-card__list-actions-main').forEach(initProductCard);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

});